<section fxLayout="column"
         fxLayoutAlign.xs="center center"
         class="animate__animated animate__fadeIn">
  <div fxLayout="column"
       fxLayoutAlign="center center"
       class="cfc-login__login-wrapper">
    <form [formGroup]="formLogin"
          fxLayout="column"
          fxLayoutAlign="center center"
          class="box-login"
          (submit)="login()">
      <img src="../../assets/images/png/logo.png">
      <h1 color="primary"
          class="mb-0 mt-4">SINDAUTO</h1>
      <mat-form-field class="w-100">
        <mat-label color="primary">Usuário</mat-label>
        <input autocomplete="off"
               formControlName="username"
               matInput
               placeholder="Usuário"
               type="text"
               #userInput
               [mask]="'000.000.000-00'" />
        <mat-error class="error-login"
                   *ngIf="formLogin.controls.username.errors">
          <span *ngIf="formLogin.controls.username.errors?.required">
            Informe seu <strong>Usuário</strong>
          </span>
          <span *ngIf="formLogin.controls.username.errors?.email">
            Informe um usuário no formato <strong>usuario@email.com</strong>
          </span>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>Senha</mat-label>
        <input autocomplete="off"
               formControlName="password"
               matInput
               [type]="showPassword ? 'text' : 'password'" />
        <mat-icon matSuffix
                  (mouseover)=" this.showPassword = !this.showPassword"
                  (mouseout)=" this.showPassword = !this.showPassword">{{showPassword ? 'visibility' :
          'visibility_off'}}</mat-icon>
        <mat-error *ngIf="formLogin.controls.password.errors">
          <span *ngIf="formLogin.controls.password.errors?.required">
            Informe sua <strong>Senha</strong>
          </span>
        </mat-error>
      </mat-form-field>

      <mat-checkbox color="primary"
                    class="w-100 mt-2"
                    formControlName="remember">Lembrar usuário</mat-checkbox>
      <button class="cfc-login__btn-login mt-4"
              mat-raised-button
              id="button-entrar"
              color="primary"
              [disabled]="formLogin.invalid"
              type="submit">
        <span color="accent" class="mr-2">
          Entrar
        </span>
        <mat-icon [@isLoading]="loading ? 'fadeOut' : 'fadeIn'"
                  *ngIf="!loading">login</mat-icon>
        <mat-spinner [@isLoading]="loading ? 'fadeIn' : 'fadeOut'"
                     diameter="20"
                     color="primary-light"
                     class="m-auto"
                     *ngIf="loading">
        </mat-spinner>
      </button>
    </form>
  </div>
</section>
